module.exports = __webpack_public_path__ + "static/media/olake-meta.df3856a8.png";